import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageCardsServiceService } from '../../credit-card-management/manage-cards-service.service';
import { AuthenticationService } from '../../_services';

@Component({
  selector: 'app-select-payment-method',
  templateUrl: './select-payment-method.component.html',
  styleUrls: ['./select-payment-method.component.scss'],
})
export class SelectPaymentMethodComponent implements OnInit {
  @Input() data: any;
  paymentDone = false;
  paymentClicked = false;
  paymentResp;
  paymentErrorResp;
  card;
  maxLength = 0;
  loading = false;
  buyerCode: string = "";
  cardIcons = {
    'visa': 'fab fa-cc-visa',
    'american express': 'fab fa-cc-amex',
    'mastercard': 'fab fa-cc-mastercard',
    'maestro': 'fab fa-cc-mastercard',
    'di': 'fab fa-cc-discover'
  }
  constructor(
    private manageCardsService: ManageCardsServiceService,
    private authenticationService: AuthenticationService,
    public activeModal: NgbActiveModal,
  ) { }

  //paymentOptionsMap

  ngOnInit() {
    // console.log("data : ", this.data);
    
    this.buyerCode = this.authenticationService.getUserID()
    this.getSavedCardsForSelectedSeller();
  }


  // getSavedCardsForSelectedSeller() {

  //   console.log('xicheck.....');
    
  //   console.log(this.data.payData.paymentOptionsMap['XiCheck']);

  //   console.log('XiCard.....');
    
  //   console.log(this.data.payData.paymentOptionsMap['XiCard']);
    

  //   // this.loading = true;
    
  //     (this.data.payData.paymentOptionsMap['XiCheck'] || []).forEach(element => {
  //       element.title = `eCheck  - XXXX - XXXX - XXXX -  ${element.accountLastFourDigit || '0000'}`;
  //       element.accountType = element.paymentOption;
  //       element.cardNumber = element.accountNumber
  //     });
    
    

  //   if(this.data.payData.paymentOptionsMap['XiCheck'] || []){
  //     this.data.payData.paymentOptionsMap['XiCard'].forEach(element => {
  //       element.title = `Card - XXXX - XXXX - XXXX - ${element.cardLastFourDigit}`;
  //       element.icon = this.cardIcons[element.cardType]
  //     });
  //   }
  //   // this.data.payData.paymentOptionsMap['Added Cards'] = addedCardsForSeller;


  //   this.loading = false;
  // }

  getSavedCardsForSelectedSeller() {

    console.log('xicheck.....');
    
    console.log(this.data.payData.paymentOptionsMap['XiCheck']);

    console.log('XiCard.....');
    
    console.log(this.data.payData.paymentOptionsMap['XiCard']);
    

    // this.loading = true;
    
      (this.data.payData.paymentOptionsMap['XiCheck'] || []).forEach(element => {
        element.title = `eCheck  - XXXX - XXXX - XXXX -  ${element.accountLastFourDigit || '0000'}`;
        element.accountType = element.paymentOption;
        element.cardNumber = element.accountNumber
        element.changePayDate = true
      });
    
    

    if(this.data.payData.paymentOptionsMap['XiCheck'] || []){
      this.data.payData.paymentOptionsMap['XiCard'].forEach(element => {
        element.title = `Card - XXXX - XXXX - XXXX - ${element.cardLastFourDigit}`;
        element.icon = this.cardIcons[element.cardType]
        element.changePayDate = true
      });
    }
    // this.data.payData.paymentOptionsMap['Added Cards'] = addedCardsForSeller;


    this.loading = false;
  }

  enterCvv(card) {
    this.paymentClicked = true;
    this.card = card;
  }


  selectCardForPayment() {
    // this.loading = true;
    var card = this.card
    this.loading = true;
    this.manageCardsService.doPayment(card, this.data.amt).subscribe(data => {
      this.paymentClicked = false;
      this.paymentDone = true;
      this.loading = false;
      if (data.success) {
        this.paymentResp = Object.keys(data.resp).map((key) => {
          return { key, data: data.resp[key][0] };
        })
      } else {
        this.paymentErrorResp = data;
      }
    }, () => {
      this.loading = false;
    });

  }


  selectPaymentOption(paymentOption) {
    console.log(`payment option ${JSON.stringify(paymentOption)}`);
    this.data.payData.payModel.bank = paymentOption;
    this.activeModal.close(paymentOption);
  }


}
